import {getEnglishPlurals} from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Beoordeel het artikel',
    message: 'Stem uitgebracht',
    votes: votes => `${getEnglishPlurals(["mening", "meningen"], +votes)},`,
    score: 'beoordeling'
  },
  feedback: {
    label: 'Is dit artikel nuttig?'
  }
};